export const DEFAULT = 'default';
